<template>
  <div class="wt2-discover-filtering">
    <div class="-group">
      <wt-search-2014 v-model="searchQuery" @trigger="triggerSearch" />

      <wt-dropdown-view
        v-if="showDropDown"
        :label="'dashboardFilter.filter' | culture"
        :transientView="true"
        type="right"
        :class="{ '-filter-is-active': !hasDefaultFilters }"
      >
        <template slot="view" slot-scope="props">
          <discovery-filters
            :close="props.close"
            :options="filters"
            @apply="applyFilters"
          />
        </template>
      </wt-dropdown-view>
    </div>
  </div>
</template>

<script>
import DiscoveryFilters from './DiscoverFilters.vue';

export default {
  name: 'discover-tab-filtering-bar',
  components: {
    DiscoveryFilters,
  },

  props: {
    showDropDown: { type: Boolean, default: true },
    filters: { type: Object, required: true },
  },

  data() {
    return {
      searchQuery: this.filters.q,
    };
  },

  computed: Object.assign({
    hasDefaultFilters() {
      const filterKeys = ['voiceOver', 'category'];
      return _.isEqual(
        _.pick(
          this.$store.state.dashboard.defaultReadyMadeVideosFilters,
          filterKeys
        ),
        _.pick(this.filters, filterKeys)
      );
    },
  }),

  methods: {
    triggerSearch() {
      this.filters.q = this.searchQuery;
      this.$emit('on-change');
    },

    applyFilters(payload) {
      Object.assign(this.filters, payload);
      this.triggerSearch();
    },
  },
};
</script>

<style lang="scss">
.wt2-discover-filtering {
  height: 60px;

  > .-group {
    display: flex;
    .wt2-search2014-component {
      width: 674px;
    }
  }

  .wt2-dropdown-view-component > .-toggle {
    height: 42px;
  }
}
</style>
